import { ReactElement } from 'react';
import Link from './Link';

interface BreadcrumbProps {
  productName: string;
  category: string;
}

export default function Breadcrumbs({ productName, category }: BreadcrumbProps): ReactElement {
  return (
    <div className="text-sm md:ml-10 mt-4 md:mt-10 text-primary-actual">
      <Link slug={`/shop/${category.toLowerCase()}`}>
        <a className="uppercase">{category} / </a>
      </Link>
      <span className="font-bold uppercase">{productName}</span>
    </div>
  );
}
